module.exports = __webpack_public_path__ + "static/media/use-case-8.162f2d1f.jpg";